export default "__VITE_ASSET__Bfl1C36Z__"